import React, { useState } from 'react';
import { getDataUTC, is3CatInfoVerificacio } from '@portal-internet/core';
import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import Etiquetes from 'components/3catinfo/Etiquetes';
import Etiqueta from 'components/3catinfo/Etiqueta';
import IconaMedia from 'components/3catinfo/IconaMedia';
import styles from './destacatUltimaNoticia.module.scss';
import { getTimeFromNow, getHora } from 'utils/3catinfo/dateHelper';
import __isEmpty from 'lodash/isEmpty';
import __isUndefined from 'lodash/isUndefined';

const DataPublicacio = (props) => {
    const { dataPublicacio } = props;

    return (
        <div className={styles.dataPublicacio} data-testid='destacat-data-publicacio'>
            <time className={styles.data} dateTime={getDataUTC(dataPublicacio)}>
                <span className={styles.hours}>
                    <span>{getTimeFromNow(dataPublicacio)}</span>
                </span>
                <span className={styles.time}>
                    <span>{getHora(dataPublicacio)}</span>
                </span>
            </time>
        </div>
    );
};

const DestacatUltimaNoticia = (props) => {
    const { item, routePath, testId, priorityImage, marcatgeAudienciesClick } = props;
    const {
        id,
        titol,
        domini,
        permatitle,
        data_publicacio,
        imatges,
        tipologia,
        autors,
        lloc,
        agrupacions,
        tags,
        videos,
        audios,
        canals_directes_embedats,
        mediadestacat
    } = item || props;
    const [isHovered, setIsHovered] = useState(false);

    if (!titol) {
        return <></>;
    }

    const isVerifica = is3CatInfoVerificacio(tags) || is3CatInfoVerificacio(agrupacions);
    const route = { slug: permatitle || titol, id: id, tipologia: tipologia, type: routePath, domini };

    return (
        <div className={styles.notiDestacatUltimaNoti} {...(testId && { 'data-testid': testId })} role='article'>
            <section className={styles.cos}>
                <div className={styles.punt}>
                    <span>&nbsp;</span>
                </div>
                <DataPublicacio dataPublicacio={data_publicacio} />
                <div className={styles.content}>
                    <div className={styles.contentTitol}>
                        {isVerifica && <div className={styles.avantitol}>3catinfo verifica</div>}
                        <h2
                            className={isHovered ? `${styles.titol} ${styles.subrratllat}` : styles.titol}
                            data-testid='destacat-titol'
                        >
                            <Enllac route={route} dataTestId='destacat-enllac' marcatgeAudienciesClick={marcatgeAudienciesClick}>
                                <span dangerouslySetInnerHTML={{ __html: titol }}></span>
                            </Enllac>
                        </h2>
                        {!__isEmpty(autors) && (
                            <div className={styles.autors}>
                                {autors?.map((autor, index) => {
                                    const isFirst = index === 0 && autors.length > 1;
                                    const isLast = index === autors.length - 1;
                                    const routeAutor = { slug: autor?.nom, id: autor?.id, tipologia: autor?.tipologia };

                                    return (
                                        <React.Fragment key={autor.id}>
                                            {!isLast && !isFirst && ', '}
                                            {isLast && autors.length > 1 && ' i '}
                                            <Enllac
                                                route={routeAutor}
                                                className={styles.enllacAutor}
                                                dataTestId={`autor_${index}`}
                                            >
                                                {autor.nom}
                                            </Enllac>
                                        </React.Fragment>
                                    );
                                })}
                            </div>
                        )}
                        {!__isEmpty(lloc) && (
                            <span className={`${styles.lloc} ${!__isEmpty(autors) ? styles.ambAutor : ''}`}>{lloc}</span>
                        )}
                    </div>
                    <div className={styles.contentImg}>
                        {imatges && (
                            <div
                                className={styles.imatgeWrapper}
                                data-testid='destacat-content-imatge'
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                            >
                                <Enllac route={route} dataTestId='destacat-enllac-imatge'>
                                    <div className={styles.labelWrapper} data-testid='etiqueta'>
                                        {canals_directes_embedats ? (
                                            <Etiqueta
                                                className={styles.labelDirecte}
                                                text='En directe'
                                                icona='directes'
                                                isBlanc={true}
                                                tipus='highlight'
                                            />
                                        ) : (
                                            <Etiquetes agrupacions={agrupacions} tags={tags} id={id} />
                                        )}
                                    </div>
                                    <IconaMedia
                                        videos={videos}
                                        audios={audios}
                                        canals_directes_embedats={canals_directes_embedats}
                                        mediadestacat={mediadestacat}
                                    />
                                    <Imatge
                                        alt={imatges?.[0]?.alt || titol}
                                        imatges={imatges}
                                        className={styles.imatge}
                                        tipus='web_destacat'
                                        aria-hidden='true'
                                        layout='fill'
                                        objectFit='cover'
                                        crop='1903'
                                        data_testid='destacat-img'
                                        priority={priorityImage}
                                    />
                                </Enllac>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default DestacatUltimaNoticia;
